import { render } from "./post_status_form.vue?vue&type=template&id=4b34c9d8"
import script from "./post_status_form.js?vue&type=script&lang=js&external"
export * from "./post_status_form.js?vue&type=script&lang=js&external"

import "./post_status_form.vue?vue&type=style&index=0&id=4b34c9d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__